import { isDefined } from '../../functions/is-defined.function';
import { Filter, FilterOptions, FilterPredicateSelector } from '../types/filter';
import { filters } from './filter.operators';

function getFilter(operator: string): (value: unknown, options: FilterOptions<Filter>, getPredicate: FilterPredicateSelector) => boolean {
  const filterReg = filters
    .find(o => o.operator === operator);
  if(!filterReg)
    throw new Error(`[FilterService] predicate: No such filter with operator named: ${operator}`);
  return filterReg.predicate;
}

function getPredicate<T>(value: T, filter: Filter): boolean {
  const predicate = getFilter(filter.operator);
  return predicate(value, filter, (o) => getFilter(o));
}

export function filter<T>(items: T[], filter: Filter | Filter[] | ((item: T) => boolean) | null | undefined): T[] {
  if(!isDefined(filter))
    return items;
  if(typeof filter === 'function') {
    const f = filter
    return items.filter(item => f(item));
  }
  if(!Array.isArray(filter))
    filter = [filter];
  for(const f of filter)
    items = items.filter(o => getPredicate(o, f));
  return items;
}
